import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { Formik, Form } from "formik";
import SubmitButton from "../../components/Forms/SubmitButton";
import SettingsSelect from "../../components/Forms/SettingsSelect";
import { useHistory } from "react-router";
import DatePicker from "react-datepicker";

// import SettingsDatePicker from "../../components/Forms/SettingsDatePicker";

export default function ReportViewings() {
    const [loading, setLoading] = useState(false);
    const { staff } = useSelector((state) => state.auth);
    const [properties, setProperties] = useState([]);
    const [appointmentTypes, setAppointmentTypes] = useState([]);
    const [viewingsData, setViewingsData] = useState([]);
    const [showData, setShowData] = useState(false);
    const [commentsModal, setCommentsModal] = useState({ open: false, appointmentId: null, appointmentName: '', comments: [], loading: false });

    const { current_staff } = useSelector((state) => state.auth);
    const { settings } = useSelector((state) => state.settings);
    const history = useHistory();
    const [allowClick, setAllowClick] = useState(true);

    const [dateRangeReport, setDateRangeReport] = useState([null, null]);
    const [startDateReport, endDateReport] = dateRangeReport;
    const [searchTerm, setSearchTerm] = useState("");
    const [walkInOnly, setWalkInOnly] = useState(false);

    const getAppointmentTypeDisplay = (appointmentUrl, description) => {
        // Check if description contains "Walk-in viewing (QR code scan)" or similar
        if (description && description.toLowerCase().includes('walk-in')) {
            return `${appointmentUrl} (Walk-In)`;
        }
        return appointmentUrl;
    };

    const getStatusText = (statusCode) => {
        switch (statusCode) {
            case 1:
                return 'Pending';
            case 2:
                return 'Confirmed';
            case 3:
                return 'Completed';
            default:
                return 'Unknown';
        }
    };

    const getStatusBadgeClass = (statusCode) => {
        switch (statusCode) {
            case 1:
                return 'bg-yellow-100 text-yellow-800';
            case 2:
                return 'bg-blue-100 text-blue-800';
            case 3:
                return 'bg-green-100 text-green-800';
            default:
                return 'bg-gray-100 text-gray-800';
        }
    };

    const getNoShowStatusBadgeClass = (status) => {
        switch (status) {
            case 'Pending':
                return 'bg-yellow-100 text-yellow-800';
            case 'In Progress':
                return 'bg-blue-100 text-blue-800';
            case 'Complete':
                return 'bg-green-100 text-green-800';
            case 'No Show BM':
                return 'bg-red-100 text-red-800';
            case 'No Show Tenant':
                return 'bg-orange-100 text-orange-800';
            case 'Awaiting Parts':
                return 'bg-purple-100 text-purple-800';
            default:
                return 'bg-gray-100 text-gray-800';
        }
    };

    const openCommentsModal = async (appointmentId, appointmentName) => {
        setCommentsModal({ open: true, appointmentId, appointmentName, comments: [], loading: true });
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}appointment/${appointmentId}/comments`);
            setCommentsModal(prev => ({ ...prev, comments: response.data.comments || [], loading: false }));
        } catch (error) {
            console.log('Failed to fetch comments:', error);
            setCommentsModal(prev => ({ ...prev, comments: [], loading: false }));
        }
    };

    useEffect(async () => {
        axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}properties`,
        })
            .then((response) => {
                // let responseData = [{id: 0, value:0, label: "All"}];
                // setProperties(responseData.concat(response.data));
                setProperties(response.data);
            })
            .catch((error) => {
                alert("properties failed");
            });

        axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}appointment_types_list`,
        })
            .then((response) => {
                setAppointmentTypes(response.data);
            })
            .catch((error) => {
                console.log("Failed to fetch appointment types:", error);
            });

        if (history.action == "POP") {
            if (allowClick === true) {
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}channels`,
                });
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}tagsList`,
                });
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}collectionList`,
                });
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}mentionList/${current_staff.id}`,
                });

                if (settings && settings.brokers === 1) {
                    axios({
                        method: "get",
                        url: `${process.env.REACT_APP_API_URL}brokers`,
                    });
                }

                setAllowClick(false);
            }
        }
    }, []);

    return (
        <>
            <div className="w-auto bg-gray-100 my-6 xl:my-0 xl:mx-4 rounded-3xl flex-1 p-5">
                <h1>Export All</h1>

                <Formik
                    initialValues={{
                        property_id: 0,
                        startDateReport: "",
                        endDateReport: "",
                        report_type: "appointments_list",
                        appointment_type: "all",
                        no_show_status: "all",
                    }}
                    onSubmit={async (values, { setSubmitting, setErrors, resetForm }) => {
                        setLoading(true);
                        
                        // Appointments Per Person Per Day - email delivery
                        if (values.report_type === 'appointments_per_person_per_day') {
                            await axios({
                                method: "post",
                                url: `${process.env.REACT_APP_API_URL}reports/export_viewings`,
                                data: { 
                                    property_id: values.property_id, 
                                    start_date: startDateReport, 
                                    end_date: endDateReport, 
                                    appointment_type: values.appointment_type,
                                    report_type: values.report_type,
                                    staff_id: current_staff.id
                                },
                            })
                                .then((response) => {
                                    alert(`Report generation started! You will receive an email at ${response.data.email} when it is ready.`);
                                })
                                .catch((error) => {
                                    console.log(error);
                                    alert("Failed to start report generation. Please try again.");
                                });
                        } else if (values.report_type === 'appointments_list') {
                            // Appointments List - fetch and display data
                            await axios({
                                method: "post",
                                url: `${process.env.REACT_APP_API_URL}reports/get_viewings_data`,
                                data: { 
                                    property_id: values.property_id, 
                                    start_date: startDateReport, 
                                    end_date: endDateReport, 
                                    appointment_type: values.appointment_type,
                                    no_show_status: values.no_show_status,
                                },
                            })
                                .then((response) => {
                                    setViewingsData(response.data);
                                    setShowData(true);
                                })
                                .catch((error) => {
                                    console.log(error);
                                    alert("Failed to fetch data. Please try again.");
                                });
                        } else {
                            // Appointments by Day - immediate download
                            await axios({
                                method: "post",
                                url: `${process.env.REACT_APP_API_URL}reports/export_viewings`,
                                responseType: "blob",
                                data: { 
                                    property_id: values.property_id, 
                                    start_date: startDateReport, 
                                    end_date: endDateReport, 
                                    appointment_type: values.appointment_type,
                                    report_type: values.report_type
                                },
                            })
                                .then((response) => {
                                    const href = URL.createObjectURL(response.data);

                                    const link = document.createElement("a");
                                    link.href = href;
                                    link.setAttribute("download", "ViewingsReport.xlsx");
                                    document.body.appendChild(link);
                                    link.click();

                                    document.body.removeChild(link);
                                    URL.revokeObjectURL(href);
                                })
                                .catch((error) => {
                                    console.log(error);
                                    alert("Failed to download report. Please try again.");
                                });
                        }

                        setLoading(false);
                        setSubmitting(false);
                    }}
                >
                    {({ values, errors, setFieldValue, handleSubmit, isValid, isSubmitting, dirty }) => (
                        <Form onSubmit={handleSubmit}>
                            <div>
                                <div className="grid lg:grid-cols-12 md:lg:grid-cols-6 gap-12 mt-5 mb-5 ">
                                    <SettingsSelect
                                        label="Report Type"
                                        name="report_type"
                                        onChange={setFieldValue}
                                        value={values.report_type}
                                        options={[
                                            { label: "Appointments List", value: "appointments_list" },
                                            { label: "Appointments Per Person Per Day", value: "appointments_per_person_per_day" },
                                            { label: "Appointments by Day and Type", value: "appointments_by_day" },
                                        ]}
                                    />

                                    <SettingsSelect
                                        label="What is your desired Building?"
                                        name="property_id"
                                        onChange={setFieldValue}
                                        value={values.property_id}
                                        options={[{ label: "All Properties", value: "" }, ...properties]}
                                    />

                                    <SettingsSelect
                                        label="Appointment Type"
                                        name="appointment_type"
                                        onChange={setFieldValue}
                                        value={values.appointment_type}
                                        options={[
                                            { label: "All", value: "all" },
                                            ...appointmentTypes.map(type => ({
                                                label: type.name,
                                                value: type.name
                                            }))
                                        ]}
                                    />

                                    <SettingsSelect
                                        label="Appointment Status"
                                        name="no_show_status"
                                        onChange={setFieldValue}
                                        value={values.no_show_status}
                                        options={[
                                            { label: "All", value: "all" },
                                            { label: "Pending", value: "Pending" },
                                            { label: "In Progress", value: "In Progress" },
                                            { label: "Complete", value: "Complete" },
                                            { label: "No Show BM", value: "No Show BM" },
                                            { label: "No Show Tenant", value: "No Show Tenant" },
                                            { label: "Awaiting Parts", value: "Awaiting Parts" },
                                        ]}
                                    />

                                    <div className="col-span-3">
                                        <label className="text-sm font-medium mt-5 text-gray-700">
                                            <span>Choose a date range</span>
                                        </label>
                                        <DatePicker
                                            selectsRange={true}
                                            startDate={startDateReport}
                                            endDate={endDateReport}
                                            onChange={(update) => {
                                                setDateRangeReport(update);
                                            }}
                                            label={"Date Range"}
                                            dateFormat={"d MMMM yyyy"}
                                            isClearable={true}
                                            showYearDropdown
                                            showMonthDropdown
                                            className="z-20 block w-full font-light border border-gray-300 shadow-sm mt-1 py-2 pl-2 rounded-lg focus:outline-none focus:ring-primary focus:border-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
                                        />
                                    </div>

                                    {/* <SettingsSelect label="Year" name="year_id" onChange={setFieldValue} value={values.year_id} options={years} /> */}
                                </div>

                                {values.report_type === 'appointments_per_person_per_day' && (
                                    <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                                        <p className="text-sm text-blue-800">
                                            <strong>Note:</strong> This report fetches data from Asana and will be generated in the background. You will receive an email when it is ready (may take a few minutes).
                                        </p>
                                    </div>
                                )}

                                <SubmitButton 
                                    name="Submit" 
                                    disabled={!isValid || isSubmitting || !dirty} 
                                    isSubmitting={isSubmitting} 
                                    text={
                                        values.report_type === 'appointments_per_person_per_day' 
                                            ? 'Generate Report (Email)' 
                                            : values.report_type === 'appointments_list'
                                            ? 'View Report'
                                            : 'Download Report'
                                    } 
                                />
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>

            {showData && viewingsData.length > 0 && (
                <div className="w-auto bg-white my-6 xl:my-0 xl:mx-4 rounded-3xl flex-1 p-5 shadow-lg">
                    <div className="flex justify-between items-center mb-4">
                        <h2 className="text-xl font-semibold">Appointments Report ({viewingsData.filter(appointment => {
                            // Walk-in filter
                            if (walkInOnly && (!appointment.description || !appointment.description.toLowerCase().includes('walk-in'))) {
                                return false;
                            }
                            // Search filter
                            if (!searchTerm) return true;
                            const search = searchTerm.toLowerCase();
                            return (
                                appointment.name?.toLowerCase().includes(search) ||
                                appointment.booking_ref?.toLowerCase().includes(search) ||
                                appointment.property_name?.toLowerCase().includes(search) ||
                                appointment.unit_name?.toLowerCase().includes(search) ||
                                appointment.bed_name?.toLowerCase().includes(search) ||
                                appointment.appointment_url?.toLowerCase().includes(search) ||
                                appointment.description?.toLowerCase().includes(search) ||
                                appointment.bm_name?.toLowerCase().includes(search) ||
                                appointment.email?.toLowerCase().includes(search) ||
                                appointment.cell?.toLowerCase().includes(search)
                            );
                        }).length} records)</h2>
                        <button
                            onClick={async () => {
                                const formValues = {
                                    property_id: viewingsData[0]?.property_id || 0,
                                    start_date: startDateReport,
                                    end_date: endDateReport,
                                    appointment_type: 'all',
                                    no_show_status: 'all',
                                    report_type: 'appointments_list'
                                };
                                
                                await axios({
                                    method: "post",
                                    url: `${process.env.REACT_APP_API_URL}reports/export_viewings`,
                                    responseType: "blob",
                                    data: formValues,
                                })
                                    .then((response) => {
                                        const href = URL.createObjectURL(response.data);
                                        const link = document.createElement("a");
                                        link.href = href;
                                        link.setAttribute("download", "ViewingsReport.xlsx");
                                        document.body.appendChild(link);
                                        link.click();
                                        document.body.removeChild(link);
                                        URL.revokeObjectURL(href);
                                    })
                                    .catch((error) => {
                                        console.log(error);
                                        alert("Failed to download report. Please try again.");
                                    });
                            }}
                            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
                        >
                            Download Excel
                        </button>
                    </div>

                    <div className="mb-4 flex items-center gap-4">
                        <input
                            type="text"
                            placeholder="Search by name, ref, property, unit, bed, type, description, BM name, email, or cell..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        />
                        <label className="flex items-center space-x-2 cursor-pointer whitespace-nowrap">
                            <input
                                type="checkbox"
                                checked={walkInOnly}
                                onChange={(e) => setWalkInOnly(e.target.checked)}
                                className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                            />
                            <span className="text-sm font-medium text-gray-700">Walk-In only</span>
                        </label>
                    </div>

                    <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
                                    <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name / Ref</th>
                                    <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Property / Unit{process.env.REACT_APP_COLOUR !== 'QL' ? ' / Bed' : ''}</th>
                                    <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Type</th>
                                    <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
                                    <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Time</th>
                                    <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                                    <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Appt Status</th>
                                    <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Comments</th>
                                    <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Description</th>
                                    <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">BM Name</th>
                                    <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Response</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {viewingsData.filter(appointment => {
                                    // Walk-in filter
                                    if (walkInOnly && (!appointment.description || !appointment.description.toLowerCase().includes('walk-in'))) {
                                        return false;
                                    }
                                    // Search filter
                                    if (!searchTerm) return true;
                                    const search = searchTerm.toLowerCase();
                                    return (
                                        appointment.name?.toLowerCase().includes(search) ||
                                        appointment.booking_ref?.toLowerCase().includes(search) ||
                                        appointment.property_name?.toLowerCase().includes(search) ||
                                        appointment.unit_name?.toLowerCase().includes(search) ||
                                        appointment.bed_name?.toLowerCase().includes(search) ||
                                        appointment.appointment_url?.toLowerCase().includes(search) ||
                                        appointment.description?.toLowerCase().includes(search) ||
                                        appointment.bm_name?.toLowerCase().includes(search) ||
                                        appointment.email?.toLowerCase().includes(search) ||
                                        appointment.cell?.toLowerCase().includes(search)
                                    );
                                }).map((appointment) => (
                                    <tr key={appointment.id} className="hover:bg-gray-50">
                                        <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-900">{appointment.id}</td>
                                        <td className="px-3 py-3 text-sm text-gray-900">
                                            <div className="font-medium">{appointment.name}</div>
                                            <div className="text-xs">
                                                {appointment.booking_id ? (
                                                    <a
                                                        href={`${process.env.REACT_APP_API_URL.replace('/api/', '/')}chat/${appointment.booking_id}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="text-blue-600 hover:underline"
                                                    >
                                                        {appointment.booking_ref}
                                                    </a>
                                                ) : (
                                                    <span className="text-gray-500">{appointment.booking_ref || 'N/A'}</span>
                                                )}
                                            </div>
                                        </td>
                                        <td className="px-3 py-3 text-sm text-gray-900">
                                            <div className="font-medium">{appointment.property_name}</div>
                                            <div className="text-xs text-gray-500">
                                                {appointment.unit_name}
                                                {process.env.REACT_APP_COLOUR !== 'QL' && appointment.bed_name && ` / ${appointment.bed_name}`}
                                            </div>
                                        </td>
                                        <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-900">{getAppointmentTypeDisplay(appointment.appointment_url, appointment.description)}</td>
                                        <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-900">{appointment.booked_date}</td>
                                        <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-900">
                                            {appointment.booked_time} - {appointment.time_to}
                                        </td>
                                        <td className="px-3 py-3 whitespace-nowrap text-sm">
                                            <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusBadgeClass(appointment.status)}`}>
                                                {getStatusText(appointment.status)}
                                            </span>
                                        </td>
                                        <td className="px-3 py-3 whitespace-nowrap text-sm">
                                            <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${getNoShowStatusBadgeClass(appointment.no_show_status || 'Pending')}`}>
                                                {appointment.no_show_status || 'Pending'}
                                            </span>
                                        </td>
                                        <td className="px-3 py-3 whitespace-nowrap text-sm text-center">
                                            <button
                                                onClick={() => openCommentsModal(appointment.id, appointment.name)}
                                                className={`inline-flex items-center justify-center w-8 h-8 rounded-full text-xs font-semibold transition ${
                                                    appointment.comments_count > 0
                                                        ? 'bg-blue-100 text-blue-800 hover:bg-blue-200 cursor-pointer'
                                                        : 'bg-gray-100 text-gray-400 hover:bg-gray-200 cursor-pointer'
                                                }`}
                                                title="View comments"
                                            >
                                                {appointment.comments_count || 0}
                                            </button>
                                        </td>
                                        <td className="px-3 py-3 text-sm text-gray-900">{appointment.description || '-'}</td>
                                        <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-900">{appointment.bm_name}</td>
                                        <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-900">{appointment.tenant_satisfaction || '-'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            {showData && viewingsData.length === 0 && (
                <div className="w-auto bg-white my-6 xl:my-0 xl:mx-4 rounded-3xl flex-1 p-5 shadow-lg">
                    <p className="text-center text-gray-500">No appointments found for the selected criteria.</p>
                </div>
            )}

            {commentsModal.open && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" onClick={() => setCommentsModal({ open: false, appointmentId: null, appointmentName: '', comments: [], loading: false })}>
                    <div className="bg-white rounded-2xl shadow-xl w-full max-w-2xl max-h-[80vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
                        <div className="flex justify-between items-center p-5 border-b">
                            <h3 className="text-lg font-semibold">Comments - {commentsModal.appointmentName} (#{commentsModal.appointmentId})</h3>
                            <button
                                onClick={() => setCommentsModal({ open: false, appointmentId: null, appointmentName: '', comments: [], loading: false })}
                                className="text-gray-400 hover:text-gray-600 text-2xl leading-none"
                            >
                                &times;
                            </button>
                        </div>
                        <div className="p-5 overflow-y-auto flex-1">
                            {commentsModal.loading ? (
                                <p className="text-center text-gray-500">Loading comments...</p>
                            ) : commentsModal.comments.length === 0 ? (
                                <p className="text-center text-gray-500">No comments yet.</p>
                            ) : (
                                <div className="space-y-4">
                                    {commentsModal.comments.map((comment) => (
                                        <div key={comment.id} className="border rounded-lg p-3">
                                            <div className="flex justify-between items-start mb-1">
                                                <span className="text-sm font-medium text-gray-900">
                                                    {comment.user?.name || comment.user?.profile?.name || 'System'}
                                                </span>
                                                <span className="text-xs text-gray-500">
                                                    {new Date(comment.created_at).toLocaleString()}
                                                </span>
                                            </div>
                                            <p className="text-sm text-gray-700 whitespace-pre-wrap">{comment.message}</p>
                                            {comment.file_details && comment.file_details.length > 0 && (
                                                <div className="mt-2 flex flex-wrap gap-2">
                                                    {comment.file_details.map((file) => (
                                                        <a
                                                            key={file.id}
                                                            href={file.path}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="text-xs text-blue-600 hover:underline"
                                                        >
                                                            {file.name || 'Attachment'}
                                                        </a>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
